import React, { useCallback, useMemo, useState } from "react";
import { track } from "../../functions/metaPixel";
import { useDispatch, useSelector } from "react-redux";
import { AddressElement } from "@stripe/react-stripe-js";
import { getInitialCountryData } from "../../functions/CountryFunctions";

// Map a selected region label to Stripe ISO country codes
const EU_COUNTRY_CODES = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
];

const getAllowedCountriesFromRegionArchive = (region) => {
  console.log("Getting allowed countries for region:", region);
  const label =
    typeof region === "string" ? region : region?.label || region?.code;
  switch (label) {
    case "EU":
      return EU_COUNTRY_CODES;
    case "UK":
      return ["GB"]; // Stripe expects GB for United Kingdom
    case "US":
      return ["US"];
    case "CA":
      return ["CA"];
    case "AU":
      return ["AU"];
    case "NZ":
      return ["NZ"];
    default:
      // Fallback: allow main regions
      return ["GB", "IE", "US", "NZ", "AU", "CA", ...EU_COUNTRY_CODES];
  }
};

const getAllowedCountriesFromRegion = (region) => {
  // Always allow these countries for now
  return ["GB", "IE", "US", "NZ", "AU", "CA", ...EU_COUNTRY_CODES];
};

const Shipping = ({ onSubmit }) => {
  const dispatch = useDispatch();
  const shippingInfo = useSelector((state) => state.shipping.shipping);
  const [email, setEmail] = useState(shippingInfo.email || "");
  const [addressComplete, setAddressComplete] = useState(false);
  const [addressValue, setAddressValue] = useState({});
  const selectedRegion = getInitialCountryData();
  const allowedCountries = useMemo(
    () => getAllowedCountriesFromRegion(selectedRegion.selectedCountry),
    [selectedRegion],
  );

  const addressOptions = useMemo(
    () => ({
      mode: "shipping",
      allowedCountries,
      fields: { phone: "never" },
      base: {
        color: "var(--color-subheading)",
        fontFamily: "var(--font-family)",
      },
    }),
    [allowedCountries],
  );
  const onAddressChange = useCallback((event) => {
    setAddressComplete(event.complete);
    setAddressValue(event.value);
  }, []);

  const isFormValid = email && addressComplete;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid) {
      const shippingInfo = {
        email,
        ...addressValue,
      };
      dispatch({ type: "SHIPPING_SET", payload: shippingInfo });
      // Meta Pixel: Track AddShippingInfo
      track("AddShippingInfo");
      window.scrollTo({ top: 0, behavior: "smooth" });
      onSubmit(shippingInfo);
    }
  };

  return (
    <form className="shipping-form" onSubmit={handleSubmit}>
      <h2>Shipping Information</h2>
      <p className="text-center">
        Enter your details to continue to secure payment
      </p>
      <label>
        <span className="shipping-label">Email</span>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="shipping-input"
          placeholder=""
        />
      </label>
      <AddressElement options={addressOptions} onChange={onAddressChange} />
      <button
        type="submit"
        className="shipping-btn"
        disabled={!isFormValid}
        style={{
          opacity: isFormValid ? 1 : 0.5,
          cursor: isFormValid ? "pointer" : "not-allowed",
        }}
      >
        Continue
      </button>
    </form>
  );
};

export default React.memo(Shipping);
